import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, RendererStyleFlags2, ViewChild } from '@angular/core';
import { environment } from '@teem/environments/environment';
import { ApplePayService } from '@teem/services/apple-pay.service';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';

@Component({
  selector: 'apple-pay',
  templateUrl: './apple-pay.component.html',
  styleUrls: ['./apple-pay.component.scss']
})
export class ApplePayComponent implements OnInit, AfterViewInit {
  @ViewChild('applePay', { static: false }) applyPayButton: ElementRef<any>;
  @Input() planType: any;
  @Input() planFrequency: any;
  @Input() couponDetail: any;
  @Input() planAmount: number;

  userDetails: any;
  activePlan: any;
  finalAmount: any = 0;
  buttonType: string = 'new-user';

  @Input('userDetails')
  set setUserDetails(value: any) {
    this.userDetails = value;
    this.activePlan = value.subscription;
  }

  @Input('buttonType')
  set setButtonType(value: any) {
    this.buttonType = value;
  }


  constructor(
    private renderer: Renderer2,
    private applePayService: ApplePayService,
  ) { }

  ngOnInit() {
    if (this.buttonType == 'upgrade-user') {
      let self = this;
      this.finalAmount = this.getAmount().then(
        function (amount) {
          self.finalAmount = amount;
          // console.log(self.finalAmount);
          return amount;
        },
        function (e) {
          return 0;
        }
      );
    }
  }

  ngAfterViewInit() {
    if (this.browserSupport()) {
      try {
        const button = this.renderer.createElement('apple-pay-button');
        this.renderer.setAttribute(this.applyPayButton.nativeElement, 'locale', (window as any).LOCALE);
        this.renderer.setStyle(this.applyPayButton.nativeElement, 'display', 'inline', RendererStyleFlags2.Important);
        this.renderer.appendChild(this.applyPayButton.nativeElement, button);
      } catch (error) {
        console.log("Default=->" + error);
      }
    } else {
      console.log("browser not support");
    }
  }

  async callApplePay(request?: string) {
    let details = this.planDetails;
    if (request == 'upgrade-user') {
      await this.upgradePlan();
      if (request == 'upgrade-user') {
        if (this.finalAmount > 0) {
          details.finalAmount = this.finalAmount;
        } else {
          return false;
        }
      }
      console.log(details);
    }
    // Define ApplePayPaymentRequest
    const session = await this.createSession(details.finalAmount);
    session.onvalidatemerchant = (event) => {
      this.applePayService.validateMerchantSession(event.validationURL).then(
        function (response) {
          console.log(response);
          session.completeMerchantValidation(response);
        },
        function (error) {
          console.log(error);
        }
      );
    };

    session.onpaymentmethodselected = (event: any) => {
      // Define ApplePayPaymentMethodUpdate based on the selected payment method.
      // No updates or errors are needed, pass an empty object.
      let finalAmount = this.planAmount;
      if (this.couponDetail) {
        finalAmount = this.couponDetail.discount_amount;
      }
      if (this.buttonType == 'upgrade-user') {
        if (this.finalAmount > 0) {
          finalAmount = this.finalAmount;
        }else{
          return false;
        }
      }
      const update = {
        newTotal: {
          label: `Teem App ${this.planType}  ${this.planFrequency} Total`,
          amount: finalAmount
        }
      };
      session.completePaymentMethodSelection(update);
    };

    session.onpaymentauthorized = (event: any) => {
      const params = {
        couponDetail: this.couponDetail ? this.couponDetail : null,
        subscription_plan: this.planType ? this.planType : null,
        plan_frequency: this.planFrequency ? this.planFrequency : null,
        token: event.payment.token
      }
      console.log('event.payment', params);
      this.applePayService.authorizePayment(this.userDetails.uuid, params).then(
        function (response: any) {
          response = JSON.parse(response);
          console.log(response);
          if (response.status) {
            const result = {
              "status": (window as any).ApplePaySession.STATUS_SUCCESS
            };
            session.completePayment(result);
            Swal.fire({
              title: 'Done',
              text: 'Thank you for payment',
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              icon: 'success',
              // confirmButtonText:i18n.setting.i_am_based_in_saudi_arabia,
              // cancelButtonText:i18n.cancel
            }).then(result => {
              // if (result.value) {
                if(response.redirect_url) {
                  window.location.href = response.redirect_url;
                } else {
                  window.location.reload();
                }                
              // }
            });
            // this.successAlert('Done', 'Thank you for payment');
            // window.location.reload();
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message,
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              icon: 'error',
              // confirmButtonText:i18n.setting.i_am_based_in_saudi_arabia,
              // cancelButtonText:i18n.cancel
            }).then(result => {
              // if (result.value) {
                window.location.reload();
              // }
            });
            const result = {
              "status": (window as any).ApplePaySession.STATUS_FAILURE
            };
            session.completePayment(result);
            session.abort();
          }
        },
        function (error) {
          const result = {
            "status": (window as any).ApplePaySession.STATUS_FAILURE
          };
          session.completePayment(result);
          session.abort();
          Swal.fire({
            title: 'Error',
            text: 'Payment got cancled',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            icon: 'error',
            // confirmButtonText:i18n.setting.i_am_based_in_saudi_arabia,
            // cancelButtonText:i18n.cancel
          }).then(result => {
            if (result.value) {
              window.location.reload();
            }
          });
          // this.successAlert('Error', 'Payment got cancled');
          // window.location.reload();
        }
      );

    };

    session.oncancel = (event) => {
      console.log("Payment cancelled by WebKit");
      console.log(event);
      const result = {
        "status": (window as any).ApplePaySession.STATUS_FAILURE
      };
      session.completePayment(result);
      // this.successAlert('Error', 'Payment got cancled');
      window.location.reload();
      // Payment cancelled by WebKit
    };
    session.begin();
  }

  upgradePlan() {

    if(this.activePlan.payment_by == 'apple-pay') {
      Swal.fire({
        text: i18n.setting.you_cannot_upgrade_package,
        confirmButtonText:i18n.ok,
        icon: 'info'
      })
      return;
    }

    return new Promise((resolve, reject) => {
      if (this.activePlan.is_cancelled) {
        Swal.fire({
          title: i18n.setting.resume_subscription_to_upgrade_plan,
          confirmButtonText: i18n.ok,
          icon: 'info'
        })
        return;
      }

      this.selectPlan()
      resolve(true);        
      // Swal.fire({
      //   title: i18n.setting.based_outside_saudi_arabia,
      //   text: i18n.setting.upgrade_plan_confirm,
      //   showCloseButton: true,
      //   showCancelButton: true,
      //   focusConfirm: false,
      //   confirmButtonText: i18n.setting.i_am_based_in_saudi_arabia,
      //   cancelButtonText: i18n.cancel
      // }).then(result => {
      //   this.selectPlan()
      //   resolve(true);
      // });
    })
  }

  async selectPlan() {
    if (this.activePlan && !this.activePlan.is_manual && this.activePlan.plan_frequency && this.activePlan.plan_frequency !== this.planFrequency) {
      Swal.fire('', i18n.t('error.unable_to_select_plan'), 'warning')
      return;
    }
  }

  get planDetails() {
    return {
      subscription_plan: this.planType,
      plan_frequency: this.planFrequency,
      couponDetail: this.couponDetail,
      finalAmount: this.couponDetail ? this.couponDetail.discount_amount : this.planAmount
    };
  }

  getAmount() {
    return new Promise((resolve, reject) => {

      this.applePayService.finalAmount(this.planDetails).subscribe((data: any) => {
        if (data.status) {
          resolve(data.final_amount);
        }
      }, err => {
        reject(err);
      })
    })
  }

  successAlert(title, message) {
    Swal.fire({
      title: title,
      text: message,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      // confirmButtonText:i18n.setting.i_am_based_in_saudi_arabia,
      // cancelButtonText:i18n.cancel
    }).then(result => {
      if (result.value) {
        window.location.reload();
      }
    });
  }

  createSession(finalAmount) {
    const request = {
      merchantCapabilities: ["supports3DS"],
      supportedNetworks: ["masterCard", "visa", "mada"],
      countryCode: "SA",
      currencyCode: "SAR",
      total: {
        label: `Teem App ${(this.planType).stToU}  ${this.planFrequency} Total`,
        type: "final",
        amount: finalAmount
      }
    };

    // Create ApplePaySession
    return new (window as any).ApplePaySession(this.getSupportedVersion(10), request);
  }

  browserSupport = function () {
    if ((window as any).ApplePaySession) {
      if (this.canMakePayments(environment.APPLE_PAY_MERCHANT_ID)) {
        return true;
      }
    }
    return false;
  };

  canMakePayments = function (merchantIdentifier) {
    return new Promise(function (resolve, reject) {
      const promise = (window as any).ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
      promise.then(function (canMakePayments) {
        console.log(canMakePayments);
        if (canMakePayments) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  };

  getSupportedVersion = function (version) {
    if (version == 1) {
      return 1;
    } else if ((window as any).ApplePaySession.supportsVersion(version)) {
      return version;
    } else {
      return this.getSupportedVersion(version - 1);
    }
  };
}


